module.exports = __webpack_public_path__ + "img/nap-trio-slide.7018815.jpg";